import styles from "./GridContainer.module.scss";

const GridContainer = ({ children }: { children: any }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default GridContainer;
